import { theme } from "@tm/utility/global";
import styled from "styled-components";

export const RecentSearchCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  font-size: 12px;
  font-weight: 400;
  padding: 8px 12px;
  background-color: ${theme.whiteText};
  box-shadow: 0px 1px 4px 0px #00000033;
  border-radius: 8px;
  cursor: pointer;
  max-width: 210px;
`;

export const CountryNameText = styled.div`
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
